module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"FooterMain":{"navigation":{"ariaLabel":"Menu v zápatí"}}},"de":{"FooterMain":{"navigation":{"ariaLabel":"Menü in der Basiszeile"}}},"sk":{"FooterMain":{"navigation":{"ariaLabel":"Menu v zápätí"}}}}')
  delete Component.options._Ctor
}
